import { render, staticRenderFns } from "./BarChartUserActive.vue?vue&type=template&id=23393f8c&"
import script from "./BarChartUserActive.vue?vue&type=script&lang=js&"
export * from "./BarChartUserActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports